<template>
  <div class="studentsList">
    <!-- <div class="title">
      <div class="inlineBlock"><el-button class="backButton">返回</el-button></div>
      <div class="inlineBlock titleText">日程 》 项目名称</div>
    </div> -->
    <el-card>
      <!-- 添加按钮 -->
      <div style="text-align:left;width:100%;height:50px;line-height:50px;">
        <el-button class="addStudent float_left" type="primary" @click="dialogVisible = true">添加学生</el-button>
        <el-button class="deleteStudent float_left" type="primary" @click="showdelmanystudentDialog">删除</el-button>
        <div class="searchStudent float_left">
          <el-input clearable placeholder="请输入学号或姓名" v-model="search" @clear="getstudentslist">
            <el-button slot="append" class="el-icon-search" @click="getstudentslist"></el-button>
          </el-input>
        </div>
        <el-button class="addStudent float_right" type="primary" @click="showalloutDialog">统一签出</el-button>
        <el-button class="addStudent float_right" type="primary" @click="showallsignDialog">统一签到</el-button>
        <div class="sendNotice float_right" @click="showNoticeDialog">发送通知</div>
        <div class="exportBtn float_right">
          <el-dropdown :hide-on-click="false">
            <span class="el-dropdown-link">导出表格</span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <div class="codeItem" @click="exportStudentListSimple">标准模板</div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="codeItem" @click="exportStudentListTemplate_1">模板1</div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="showCode float_right">
          <el-dropdown :hide-on-click="false">
            <span class="el-dropdown-link">二维码
              <!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <div class="codeItem" @click="showSignInCode">签到码</div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="codeItem" @click="showSignOutCode">签出码</div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="codeItem" @click="courseCode">日程码</div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        
      </div>
      <!-- 学生列表表格 -->
      <el-table header-row-class-name="el-customHead" :data="studentslistData" stripe style="width: 100%"
        @selection-change="selectDelStudent">
        <!-- 复选框 -->
        <el-table-column type="selection" width="80">
        </el-table-column>
        <!-- 姓名 -->
        <el-table-column type="index" label="序号">
        </el-table-column>
        <el-table-column prop="className" label="班级" width="150"></el-table-column>
        <el-table-column prop="personal_id" label="学号" width="150"></el-table-column>
        <!-- 姓名 -->
        <el-table-column prop="name" label="姓名">
        </el-table-column>
        <!-- 到 -->
        <el-table-column label="签到">
          <template slot-scope="scope">
            <!-- <el-tag type="success" v-if="scope.row.sign_in!='-'">√</el-tag>
            <el-tag type="info" v-else>—</el-tag> -->
            <img v-if="scope.row.sign_in != '-'" class="studentSign" src="../../../assets/image/studentsign.png" alt="">
            <div v-else>—</div>
          </template>
        </el-table-column>
        <!-- 出 -->
        <el-table-column label="签出">
          <template slot-scope="scope">
            <!-- <el-tag type="success" v-if="scope.row.sign_out!='-'">√</el-tag>
            <el-tag type="info" v-else>—</el-tag> -->
            <img v-if="scope.row.sign_out != '-'" class="studentSign" src="../../../assets/image/studentsign.png" alt="">
            <div v-else>—</div>
          </template>
        </el-table-column>
        <!-- 测试 -->
        <el-table-column prop="exam_score" label="测试">
          <template slot-scope="scope">
            <span style="cursor:pointer" @click="goToExamRecordPage(scope.row)">{{ scope.row.exam_score }}</span> 
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column prop="opt_score" label="操作">
          <template slot-scope="scope">
            <span style="cursor:pointer" @click="showOptRecord(scope.row.project_id,scope.row.userid,scope.row.name,scope.row.personal_id)">{{ scope.row.opt_score }}</span> 
          </template>
        </el-table-column>
        <!-- 虚拟 -->
        <el-table-column prop="exp_score"  label="虚拟">
          <template slot-scope="scope">
            <span style="cursor:pointer" @click="getExpDataList(scope.row.project_id,scope.row.userid,scope.row.name,scope.row.personal_id)">{{ scope.row.exp_score }}</span> 
            <!-- <span style="cursor:pointer">{{ scope.row.exp_score }}</span>  -->
          </template>
        </el-table-column>
        <!-- 报告 -->
        <el-table-column label="报告">
          <template slot-scope="scope">
            <!-- <span @click="goReportPage(scope.row.project_id,scope.row.report_id,scope.row.group_id,scope.row.report_status,scope.row)" :class="['cursor',scope.row.fs == '未答题'?'fontDark':'',scope.row.fs == '已提交'?'fontWeight':'']">
              {{scope.row.fs == '未答题'? '未填写':scope.row.fs}}
            </span> -->
            <!-- <div v-if="scope.row.fs == '未采用'" class="fontDark">未采用</div> -->
            <input type="number" v-if="scope.row.fs == '未采用' || scope.row.report_status == 0" class="finallscore"
              v-model.lazy="scope.row.fs" placeholder="请输入"
              @blur="updateStudentReportScore(scope.row.userid, scope.row.project_id, scope.row.fs)">
            <div v-else-if="scope.row.fs == '未答题'" class="fontDark">未填写</div>
            <div v-else-if="scope.row.fs == '未提交'" class="fontDark">未提交</div>
            <div v-else-if="scope.row.fs == '已提交'" class="cursor fontWeight"
              @click="goReportPage(scope.row.project_id, scope.row.report_id, scope.row.group_id, scope.row.report_status, scope.row)">
              已提交</div>
            <div v-else class="cursor"
              @click="goReportPage(scope.row.project_id, scope.row.report_id, scope.row.group_id, scope.row.report_status, scope.row)">
              {{ scope.row.fs }}</div>
          </template>
        </el-table-column>
        <!-- 总分 -->
        <el-table-column label="总分">
          <template slot-scope="scope">
            <!-- <input class="finallscore"  v-model.lazy="scope.row.final_score" placeholder="请输入分数" @blur="updateUserTotalScore(scope.row.userid,scope.row.project_id,scope.row.final_score)"> -->
            <div>{{ scope.row.final_score }}</div>
          </template>
        </el-table-column>
        <!-- 座位号 -->
        <el-table-column prop="zuowei" label="座号">
        </el-table-column>
        <!-- 座位号 -->
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <div class="operateItem">
              <div class="inlineBlock signOPerate" @click="userSignIn(scope.row)">签到</div>
              <div class="inlineBlock outOperate" @click="userSignOut(scope.row)">签出</div>
              <div class="inlineBlock delOperate" @click="showdelstudentDialog(scope.row)">删除</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 添加学生弹窗 -->
    <div v-show="dialogVisible" class="addStudentDialog">
      <!-- 添加学生对话框 -->
      <el-dialog title="添加学生" :visible.sync="dialogVisible" @close="dialogVisibleClose" width="30%">
        <el-tabs v-model="addType" @tab-click="handleClick">
          <el-tab-pane label="按学号添加" name="1">
            <span style="font: normal normal normal 1rem Source Han Sans CN ;">输入学生学号，将学生加入本开放单元，多个学生请用空格隔开</span>
            <el-input class="personal_id" v-model="studentNumber" @input="getStudentToOpenList"
              placeholder="请输入学号"></el-input>
            <el-table v-show="addstudentList.length > 0" :data="addstudentList" style="width: 100%">
              <el-table-column prop="index" label="序号" width="80">
              </el-table-column>
              <el-table-column prop="personal_id" label="学号" width="160">
              </el-table-column>
              <el-table-column prop="name" label="姓名">
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="按班级添加" name="2">
            <span style="font: normal normal normal 1rem Source Han Sans CN;">选择班级(可多选)，将班级内所有学生加入本开放单元</span>
            <el-select class="select_group" v-model="group_id" multiple placeholder="请选择班级(可多选)">
              <el-option v-for="item in underList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-tab-pane>
        </el-tabs>
        <span slot="footer" class="dialog-footer">
          <el-button class="themecancelButton" @click="dialogVisible = false">取消</el-button>
          <el-button class="themeButton" type="primary" @click="addstudent">添加</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 统一签到对话框 -->
    <div v-show="allSigndialogVisible" class="allSignStudentDialog">
      <el-dialog title="提示" :visible.sync="allSigndialogVisible" width="30%">
        <span style="font: normal normal normal 1rem Source Han Sans CN ;">确认统一签到吗？</span>
        <span slot="footer" class="dialog-footer">
          <el-button class="themecancelButton" @click="allSigndialogVisible = false">取消</el-button>
          <el-button class="themeButton" type="primary" @click="allSignIn">确认</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 统一签到对话框 -->
    <div v-show="allOutdialogVisible" class="allOutStudentDialog">
      <el-dialog title="提示" :visible.sync="allOutdialogVisible" width="30%">
        <span style="font: normal normal normal 1rem Source Han Sans CN ;">确认统一签出吗？</span>
        <span slot="footer" class="dialog-footer">
          <el-button class="themecancelButton" @click="allOutdialogVisible = false">取消</el-button>
          <el-button class="themeButton" type="primary" @click="allSignOut">确认</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 删除单个学生对话框 -->
    <div v-show="deldialogVisible" class="delStudentDialog">
      <el-dialog title="提示" :visible.sync="deldialogVisible" width="30%">
        <span style="font: normal normal normal 1rem Source Han Sans CN ;">删除操作无法撤销，您确定要删除该学生吗？</span>
        <span slot="footer" class="dialog-footer">
          <el-button class="themecancelButton" @click="deldialogVisible = false">取消</el-button>
          <el-button class="themeButton" type="primary" @click="deleteStudent">删除</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 删除多个学生对话框 -->
    <div v-show="delmanydialogVisible" class="delmanyStudentDialog">
      <el-dialog title="提示" :visible.sync="delmanydialogVisible" width="30%">
        <span style="font: normal normal normal 1rem Source Han Sans CN ;">删除操作无法撤销，您确定要删除这些学生吗？</span>
        <span slot="footer" class="dialog-footer">
          <el-button class="themecancelButton" @click="delmanydialogVisible = false">取消</el-button>
          <el-button class="themeButton" type="primary" @click="deleteManyStudent">删除</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 签到签出码对话框 -->
    <el-dialog class="signCodeDialog" :title="name" :visible.sync="SignInorOutVisible" @close="closeTimeIntervel"
      width="30%" center>
      <div class="signInorOutCodeTime">{{ signInorOutCodeTime }}</div>
      <div class="SignCode">
        <div class="signInorOutCodeTitle">{{ signInorOutCodeTitle }}</div>

        <img :src="SignInorOutCodeImgSrc" style="width: 15.5rem; height: 15.5rem" alt="">
        <!-- <el-image
      style="width: 15.5rem; height: 15.5rem"
      :src="SignInorOutCodeImgSrc"
></el-image> -->
        <h4>{{ timenow }}</h4>
        <span slot="footer" class="dialog-footer">
          <el-button class="clostSignCode" type="primary" @click="closeSubjectDialog">关闭</el-button>
        </span>
      </div>
    </el-dialog>
    <!-- 复制学生学号用的文本框 -->
    <div v-show="sendNoticeDialogVisible" class="sendNoticeDialog">
      <el-dialog @close="noticeDialogClose" title="发送通知" :visible.sync="sendNoticeDialogVisible">
        <div class="tips">公众号消息异步推送，班级人数过多时推送较慢，切勿重复发送！小程序消息同步推送，需用户自行查询！</div>
        <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8 }" placeholder="请输入内容" v-model="noticeValue">
        </el-input>

        <span slot="footer" class="dialog-footer">
          <el-button class="themecancelButton" @click="sendNoticeDialogVisible = false">取消</el-button>
          <el-button class="themeButton" type="primary" @click="sendNotice">发送</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 显示学生操作确认弹窗 -->
    <div v-show="reductOKDialog" >
      <el-dialog :title="studentOptListTitle" :visible.sync="reductOKDialog" class="opt-reduct-dialog">
        <span>{{opt_content}}</span> : <span><el-input v-model="opt_reduct_score" placeholder="请输入内容" type="number" style="width:90px;"></el-input></span>
        <span slot="footer" class="dialog-footer">
          <el-button class="themecancelButton" @click="reductOKDialog = false">取消</el-button>
          <el-button class="themeButton" type="primary" @click="studentReductOK">确定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 显示学生操作扣分弹窗 -->
    <div v-show="studentOptReductDialogVisible" >
      <el-dialog :title="studentOptListTitle" :visible.sync="studentOptReductDialogVisible" class="opt-dialog">
        <span class="opt-set" @click="showUpdateOptDialog"><i class="el-icon-setting"></i>设置</span>
        <span class="opt-title" @click="showStudentOptDialog" ><i class="el-icon-s-operation"></i>操作记录</span>
        <el-table :data="projectOptList" stripe style="width: 100%">
          <el-table-column prop="des" label="描述"  ></el-table-column>
          <el-table-column prop="score" label="变动分数" width="180" >
            <template slot-scope="scope">
              <span v-if="scope.row.sign == 1">{{scope.row.score}}</span>
              <span v-if="scope.row.sign == 0">-{{scope.row.score}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" >
            <template slot-scope="scope">
              <div >
                <div class="inlineBlock delOperate" @click="openStudentReductDialog(scope.row)">点击扣分</div>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分割线：区分原有内容与新增内容 -->
        <el-divider content-position="center">操作报告</el-divider>

        <!-- 新增报告信息 -->
        <el-row :gutter="20" type="flex" align="middle">
          <el-col :span="8">
            <div class="grid-content">
              <span class="info-label">实验操作报告</span>
              <!-- <span class="info-value">{{ reportFileName || '暂无' }}</span> -->
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content">
              <span class="info-label">报告分数：</span>
              <span class="info-value">{{ reportScore == null ? '无' : reportScore + ' 分' }}</span>
            </div>
          </el-col>
          <el-col :span="8" style="text-align:right;">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-view"
              @click="onViewReport"
              :disabled="!reportFileUrl"
            >
              查看报告
            </el-button>
          </el-col>
        </el-row>

      </el-dialog>
    </div>
    <!-- 显示学生操作记录弹窗 -->
    <div v-show="studentOptListDialogVisible" >
      <el-dialog :title="studentOptListTitle" :visible.sync="studentOptListDialogVisible" class="opt-dialog">
        <el-table :data="studentOptList" stripe style="width: 100%">
          <el-table-column prop="timestamp" label="扣分时间" width="180" ></el-table-column>
          <el-table-column prop="opt_name" label="操作内容" ></el-table-column>
          <el-table-column prop="score" label="变动分数" width="80" ></el-table-column>
          <el-table-column label="操作" width="120" >
            <template slot-scope="scope">
              <div >
                <div class="inlineBlock delOperate" @click="resetStudentOpt(scope.row)">撤销</div>
                <!-- <div class="inlineBlock delOperate" >撤销</div> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>
    <!-- 显示操作列表弹窗 -->
    <div v-show="projectOptListDialogVisible" >
      <el-dialog :title="projectOptListTitle" :visible.sync="projectOptListDialogVisible" class="opt-dialog">
        <div class="project-opt">
          <!-- 内容 -->
          <span style="width:500px;"><el-input v-model="opt_des" placeholder="请输入操作详情！"></el-input></span>
          <!-- 分数 -->
          <span style="width:150px;"><el-input v-model="opt_score" placeholder="请输入操作分数" type="number"></el-input></span>
          <!-- 类型 -->
          <span style="width:120px;">
            <el-select v-model="opt_sign" placeholder="请选择">
              <el-option label="减分" value="0"></el-option>
              <el-option label="加分" value="1"></el-option>
            </el-select>
          </span>
          <!-- 按钮 -->
          <span><el-button type="primary" @click="optUpdate" style="background-color: #0D5570;width: 100px;border-color: #0D5570;">确定</el-button></span>
        </div>
        <el-table :data="projectOptList" stripe style="width: 100%">
          <el-table-column prop="des" label="规则描述"  ></el-table-column>
          <el-table-column prop="score" label="变动分数" width="100" ></el-table-column>
          <el-table-column label="加/扣分" width="120" >
            <template slot-scope="scope">
              <span v-if="scope.row.sign == '0'">扣分</span>
              <span v-else>加分</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <div class="inlineBlock outOperate" @click="getOptRecordData(scope.row)">编辑</div>
              <div class="inlineBlock delOperate" @click="delOptRecord(scope.row)">删除</div>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>
    <!-- 虚拟实验记录列表 -->
    <el-dialog :title="studentExpDataTitle" :visible.sync="studentExpDataVisiable" class="opt-dialog expdatalist">
      <div style="position: absolute;top: 20px;left: 200px;font-size: 18px;color:#0D5570;cursor:pointer;" @click="openFlushExpdataScoreDialog">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="12.613" height="14" viewBox="0 0 12.613 14">
          <image id="刷新" width="12.613" height="14" xlink:href="data:image/png;base64,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"/>
        </svg>
        刷分
      </div>
      <el-table :data="studentExpDataList" stripe style="width: 100%;height: 57vh !important;" >
        <el-table-column prop="subtime" label="关卡提交时间"  ></el-table-column>
        <el-table-column prop="score" label="分数"  ></el-table-column>
        <el-table-column label="模式"  >
          <template slot-scope="scope">
            <span v-if="scope.row.mode == '1'">练习模式</span>
            <span v-if="scope.row.mode == '2'">考核模式</span>
            <span v-if="scope.row.mode == '3'">游客模式</span>
          </template>
        </el-table-column>
        <el-table-column prop="duration" label="耗时/秒"  ></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
// 引入学生列表表格组件
import StudentsList from "@/assets/js/teacher/calendar/studentsList.js";
export default {
  ...StudentsList
}
</script>
<style lang="scss">
.expdatalist{
  .el-table {
    height: 57vh !important;
  }
  .el-dialog__body {
    padding: 17px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
  }
}

.studentsList {
  .el-dialog {
    width: 27.5rem !important;
    height: 30rem !important;
    border-radius: 12px !important;
  }
  .el-dialog__title {
    font: normal normal normal 1.125rem Source Han Sans CN;
  }
  .el-dialog__headerbtn {
    font-size: 1.4375rem;
  }
  .opt-dialog{
    .el-dialog{
      width: 62.5rem !important;
      height: 40rem !important;
      .el-table{
        height: 50vh !important;
      }
    }
  }
  .opt-reduct-dialog{
    .el-dialog{
      width: 50rem !important;
      height: auto !important;
    }
    .dialog-footer{
      font-size: 16px;
    }
  }
}
.opt-title{
  position: absolute;
  top: 22px;
  right: 140px;cursor:pointer;color:#0D5570;font-size:16px
}

.studentsList .sendNoticeDialog .el-dialog {
  width: 47rem !important;
  height: 20rem !important;
}

.studentsList .addStudentDialog .el-dialog {
  width: 47rem !important;
  height: auto !important;
}

.studentsList .delStudentDialog .el-dialog,
.studentsList .delmanyStudentDialog .el-dialog,
.studentsList .allSignStudentDialog .el-dialog,
.studentsList .allOutStudentDialog .el-dialog {
  width: 27.5rem !important;
  height: 13.5rem !important;
}

.studentsList .addStudentDialog .el-dialog__body {
  padding: 25px 20px;
}

.studentsList .delStudentDialog .el-dialog__body,
.studentsList .delmanyStudentDialog .el-dialog__body .studentsList .allSignStudentDialog .el-dialog__body,
.studentsList .allOutStudentDialog .el-dialog__body {
  padding-top: 1.875rem !important;
  height: 5.625rem;
  /* padding: 30px 20px; */
  color: #606266;
  font-size: .875rem;
  word-break: break-all;
}

.el-customHead .el-table_1_column_1,
.el-customHead .el-table_1_column_2,
.el-customHead .el-table_1_column_3,
.el-customHead .el-table_1_column_4,
.el-customHead .el-table_1_column_5,
.el-customHead .el-table_1_column_6,
.el-customHead .el-table_1_column_7,
.el-customHead .el-table_1_column_8,
.el-customHead .el-table_1_column_9,
.el-customHead .el-table_1_column_10,
.el-customHead .el-table_1_column_11 {
  background-color: #F0EFF4 !important;
}

.el-customHead .el-table_1_column_1::after {
  content: '全选';
  position: absolute;
  left: 1.975rem;
  top: 0.9rem;
}

.studentsList .searchStudent .el-input__inner {
  height: 100% !important;
  line-height: 100% !important;
}

.studentsList .searchStudent .el-input {
  height: 100%;
  float: left;
}

.studentsList .searchStudent {
  width: 12.6042vw;
  height: 2.0833vw;
  margin-left: .5vw;
}

.studentsList .addStudentDialog .el-table {
  max-height: 16.625rem;
  overflow: auto;
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #0D5570;
  border-color: #0D5570;
}

.studentsList .el-tabs__item.is-active {
  color: #0D5570;
}

.studentsList .el-tabs__active-bar {
  background-color: #0D5570;
}

.cell {
  -webkit-user-select: text;
}
</style>
<style lang='scss' scoped >
@import "@/assets/css/teacher/calendar/StudentsList.scss";
</style>